var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRetweet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 141,
    height: 141,
    viewBox: "0 0 141 141",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34 77.6878V57.3378C34 51.1711 37.7 38.8378 52.5 38.8378C67.3 38.8378 82.7167 38.8378 88.575 38.8378M88.575 38.8378L72.85 54.5628M88.575 38.8378L72.85 23.1128",
    stroke: "white",
    strokeWidth: 9.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M108 63.8122L108 84.1622C108 90.3289 104.3 102.662 89.5 102.662C74.7 102.662 59.2833 102.662 53.425 102.662M53.425 102.662L69.15 86.9372M53.425 102.662L69.15 118.387",
    stroke: "white",
    strokeWidth: 9.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRetweet);
export default __webpack_public_path__ + "static/media/retweet.3c114e973623552be098f4ed53344e89.svg";
export { ForwardRef as ReactComponent };